function initializeVayuFaqToggle() {
	const faqItems = document.querySelectorAll('.vb-faq-child-wrapper');

	faqItems.forEach((item) => {
		const icon = item.querySelector('.vb-faq-icon');
		const showType = item.dataset.showtype;
		const isFirst = item.dataset.isFirstChild === 'true';
		const expandFirst = item.dataset.expandfirst === 'true';
		const enableToggle = item.dataset.enabletoggle === 'true';
		const collapseall = item.dataset.collapseall;

		// Auto open first
		if (showType === 'accordation' && expandFirst && isFirst) {
			openItem(item, icon);
		}

		if (icon && showType === 'accordation') {
			icon.addEventListener('click', function (e) {
				e.preventDefault();
				const isOpen = item.classList.contains('open');

				if (collapseall === '1') {
					closeOtherItems(item, faqItems);
				} else {
					if (item.classList.contains('colpaseopen')) {
						item.classList.remove('colpaseopen');
					} else {
						closeOtherItems(item, faqItems);
					}
				}

				if (enableToggle) {
					isOpen ? closeItem(item, icon) : openItem(item, icon);
				} else {
					if (!isOpen) openItem(item, icon);
				}
			});
		}
	});
}

function openItem(item, icon) {
	item.classList.remove('closed');
	item.classList.add('open');
	if (icon?.dataset.activeIcon) {
		icon.innerHTML = icon.dataset.activeIcon;
	}
}

function closeItem(item, icon) {
	item.classList.remove('open');
	item.classList.add('closed');
	if (icon?.dataset.inactiveIcon) {
		icon.innerHTML = icon.dataset.inactiveIcon;
	}
}

function closeOtherItems(currentItem, allItems) {
	allItems.forEach((item) => {
		if (item !== currentItem) {
			const icon = item.querySelector('.vb-faq-icon');
			closeItem(item, icon);
		}
	});
}

document.addEventListener('DOMContentLoaded', function () {
	initializeVayuFaqToggle();
});